import React from 'react';
import { replace } from 'react-router-redux';

import {ROUTE_DERBYS} from '../../../constants/routeconstants';
import { connect } from 'react-redux';
import UserRoles from "../../../../../common/src/enums/UserRoles";
import {Link} from "react-router";
import * as AdminActions from "../../../actions/admin";
import {confirm} from "../../../utils/confirmDialog";
import {NotificationManager} from "react-notifications";
import UserFieldDataType from "../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from "../../reusable/UserFieldElement";
import moment from "moment";
import config from "../../../../../server/src/config";

class DerbysPage extends React.Component {

    static getId() {
        return ROUTE_DERBYS;
    }

    static getAllowedRoles() {
        return [UserRoles.MAIN_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            editId: null,
            sortField: 'no',
        };
    }

    componentDidMount() {
        this.props.dispatch(AdminActions.getListItems('derby'));
    }

    fields = [];
    render() {
        return this.props.derby ? <div>
            <div className="sub-page-title">
                <h2>Derbyer</h2>
            </div>
            <div id="sub-page-content" className="sub-page-content">
                <table className="data-table">
                    <thead>
                    <tr>
                        <th scope="row" className="clickable" onClick={() => {this.setState({sortField: 'no'})}}>Foreningsnr.</th>
                        <th className="clickable" onClick={() => {this.setState({sortField: 'name'})}}>Årgang</th>
                        <th>Fra</th>
                        <th>Til</th>
                        <th>Alder</th>
                        <th className="commands-column"></th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.props.derby.sort((s1, s2) => {
                        if (s1.Foreningsnr === '') return 1;
                        if (s2.Foreningsnr === '') return -1;
                        return this.state.sortField === 'no' ? (s1.Foreningsnr < s2.Foreningsnr ? -1 : 1) : s1.Aar.toString().localeCompare(s2.Aar.toString(), 'da-DK')
                    }).toArray().concat(this.state.editId === 'new' ? [this.state] : []).map(derby => {
                        return this.state.editId === null || (derby.Nr !== this.state.editId && typeof(derby.editId) === 'undefined') ? <tr key={derby.Nr} id={'row-' + derby.Nr}>
                            <th scope="row">{derby.Foreningsnr}</th>
                            <td>{derby.Aar}</td>
                            <td>{derby.Fra}</td>
                            <td>{derby.Til}</td>
                            <td>{derby.Alder}</td>
                            <td className="commands-column">
                                <i className={"fa fa-pencil " + (this.state.editId === null ? 'clickable' : 'disabled')} title="Rediger derby" onClick={() => {
                                    if (this.state.editId === null) this.setState({
                                        editId: derby.Nr,
                                        Foreningsnr: derby.Foreningsnr,
                                        Aar: derby.Aar === null ? '' : derby.Aar,
                                        Fra: derby.Fra === null ? '' : String(derby.Fra),
                                        Til: derby.Til === null ? '' : String(derby.Til),
                                        Alder: derby.Alder === null ? '' : String(derby.Alder),
                                    });
                                }}/>
                                <i className={"fa fa-trash " + (this.state.editId === null ? 'clickable' : 'disabled')} title="Slet derby" onClick={() => {
                                    if (this.state.editId === null) confirm("Slet", <span>Ønsker du at slette derby'et for forening <b>{derby.Foreningsnr} (år: {derby.Aar})</b>?</span>, () => {
                                        this.props.dispatch(AdminActions.deleteListItem('derby', derby.Nr, () => {
                                            NotificationManager.success(`Derby'et i forening ${derby.Foreningsnr} (år: ${derby.Foreningsnr}) er slettet`, "Sletning", 4000);
                                        }));
                                    });
                                }}/>
                            </td>
                        </tr> : <tr key="editor" id="row-editor" className="edit-row">
                            <th>
                                <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                  name="Foreningsnr" id="Foreningsnr" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.Foreningsnr}
                                                  autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                    //errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-130px', zIndex: 99999}}}
                                                  onChange={this.onStandardFieldChange}
                                                  ref={instance => { this.fields[0] = instance; }}
                                />
                            </th>
                            <td>
                                <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                  name="Aar" id="Aar" maxLength="2" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]} value={this.state.Aar}
                                                  autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                  onChange={this.onStandardFieldChange}
                                                  ref={instance => { this.fields[1] = instance; }}
                                />
                            </td>
                            <td>
                                <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field60" containerClassName="display-inline-block"
                                                  name="Fra" id="Fra" maxLength="4" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{4}"}]} value={this.state.Fra}
                                                  autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                  onChange={this.onStandardFieldChange}
                                                  ref={instance => { this.fields[2] = instance; }}
                                />
                            </td>
                            <td>
                                <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field60" containerClassName="display-inline-block"
                                                  name="Til" id="Til" maxLength="4" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{4}"}]} value={this.state.Til}
                                                  autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                  onChange={this.onStandardFieldChange}
                                                  ref={instance => { this.fields[3] = instance; }}
                                />
                            </td>
                            <td>
                                <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                                  name="Alder" id="Alder" maxLength="2" value={this.state.Alder}
                                                  autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                  onChange={this.onStandardFieldChange}
                                                  ref={instance => { this.fields[4] = instance; }}
                                />
                            </td>
                            <td className="commands-column">
                                <i className="fa fa-save clickable" title="Gem derby" onClick={() => {
                                    this.save();
                                }}/>
                                <i className="fa fa-undo clickable" title="Annuller" onClick={() => {
                                    this.setState({editId: null});
                                }}/>
                            </td>
                        </tr>
                    })}
                    </tbody>
                </table>
            </div>
            <div className="sub-page-actions">
                <button className={"btn-primary" + (this.state.editId === null ? '' : ' disabled')} title="Opret ny derby" onClick = {() => {
                    if (this.state.editId === null) {
                        this.setState({
                            editId: 'new',
                            Foreningsnr: '',
                            Aar: '',
                            Fra: '',
                            Til: '',
                            Alder: '',
                        });
                        setTimeout(function () {
                            const content = document.getElementById("sub-page-content");
                            content.scrollTop = content.scrollHeight;
                        });
                    }
                }}>Ny</button>
            </div>
        </div> : null;
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    save = () => {
        if (this.allInputValid()) {
            const entity = {
                Foreningsnr: this.state.Foreningsnr,
                Aar: this.state.Aar === '' ? null : this.state.Aar,
                Fra: this.state.Fra === '' ? null : this.state.Fra,
                Til: this.state.Til === '' ? null : this.state.Til,
                Alder: this.state.Alder === '' ? null : Number(this.state.Alder),
            };
            if (this.state.editId === 'new') this.props.dispatch(AdminActions.createListItemItem('derby', entity, id => {
                NotificationManager.success(`Derby'et i forening ${this.state.Foreningsnr} (år: ${this.state.Aar}) er oprettet`, "Oprettelse", 4000);
                this.setState({editId: null});
                setTimeout(function () {
                    const currentRow = document.getElementById("row-" + id);
                    currentRow.scrollIntoView(false);
                });
            }));
            else this.props.dispatch(AdminActions.updateListItem('derby', this.state.editId, entity, id => {
                NotificationManager.success(`Derby'et i forening ${this.state.Foreningsnr} (år: ${this.state.Aar}) er opdateret`, "Opdatering", 4000);

                this.setState({editId: null});
                setTimeout(function () {
                    const currentRow = document.getElementById("row-" + id);
                    currentRow.scrollIntoView(false);
                });
            }));
        }  else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }
}

const mapStateToProps = (state) => ({
    derby: state.admin.derby,
});

export default connect(mapStateToProps)(DerbysPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/lists/DerbysPage.js